export default {
	"11cf0b7b5c6a61c5511eba645594c1bb": "没有检测到支付结果",
	"07b0bca0c86195467d293061e8132870": "若已支付请点击刷新进行结果查询",
	"2396ccabf52cb680fb975e1f849f9f02": "刷新",
	"cabd57357355e6d6c246880542cf7910": "重新支付"
}
